module.exports = __webpack_public_path__ + "img/Marine Collagen Peptides.1e6f20e8.jpg";